//#region ../../node_modules/@jwplayer/fe-common/module/util/error/index.js
var STRIP = "AbortError: ";
var AbortError = class extends Error {
	name = "AbortError";
	constructor(signal) {
		let reason = "Unknown Error";
		if (signal instanceof AbortSignal) {
			reason = String(signal.reason);
			reason = reason.startsWith(STRIP) ? reason.slice(STRIP.length) : reason;
		}
		super(reason);
	}
};

//#endregion
export { AbortError };
//# sourceMappingURL=index.js.map